import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Badge } from 'reactstrap';

import { buttons as Buttons } from '@breezeway/brzw-components';

import './header.scss';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      alert,
      backButtonText,
      buttonClass,
      buttons,
      children,
      className,
      count,
      mobile,
      onBackButtonClick,
      smallBottomMargin,
      subtitle,
      title,
    } = this.props;
    return (
      <div
        className={classnames('header layout-box l__has-columns', className, {
          'header--mobile': mobile,
          'header--small-bottom-margin': smallBottomMargin,
        })}
      >
        <div className="header__main">
          {onBackButtonClick && (
            <Buttons.TextButton
              autoWidth
              className="header__back-button"
              onClick={onBackButtonClick}
              theme={Buttons.constants.BUTTON_THEMES.LINK}
            >
              <div className="icon-chevron-left button__fetching-wrapper">{backButtonText}</div>
            </Buttons.TextButton>
          )}
          <h1 className="header__title">
            {title}
            {count ? (
              <Badge color="primary" pill>
                {count}
              </Badge>
            ) : null}
          </h1>
          {subtitle && <h4 className="header__subtitle">{subtitle}</h4>}
        </div>
        <div className="header__aside layout-box">
          {alert && <div className="header__alert">{alert}</div>}
          {buttons && (
            <div className={classnames('header__buttons layout-box l__has-columns', buttonClass)}>
              {buttons}
            </div>
          )}
        </div>
        {children}
      </div>
    );
  }
}

Header.propTypes = {
  alert: PropTypes.node,
  backButtonText: PropTypes.string,
  buttonClass: PropTypes.string,
  buttons: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  children: PropTypes.any,
  className: PropTypes.string,
  count: PropTypes.number,
  mobile: PropTypes.bool,
  onBackButtonClick: PropTypes.func,
  smallBottomMargin: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

Header.defaultProps = {
  backButtonText: 'Back',
  className: '',
};

export default Header;
